import '@/i18n/template/util/util.js'
import i18n from '@/i18n'
import dayjs from 'dayjs'
import { Message } from 'element-ui'
import { formatYearMonthDay } from './date'
import { API_ENV } from '@/config'

export const formatTimeTemplate = 'DD/MM/YYYY HH:mm:ss'
export const formatDateTemplate = 'DD/MM/YYYY'
export const formatMonthTemplate = 'MM/YYYY'
export const cbpDateTemplate = 'YYYYMMDD'
export const cbpMonthTemplate = 'YYYYMM'

// 暂存原始的 format 方法
const dayjsFormat = dayjs.prototype.format
// format添加默认格式化值
dayjs.prototype.format = function (template = formatTimeTemplate) {
  return dayjsFormat.call(this, template)
}
// format添加默认格式化值
dayjs.prototype.formatDate = function (template = formatDateTemplate) {
  return dayjsFormat.call(this, template)
}
// format添加默认格式化值
dayjs.prototype.formatMonth = function (template = formatMonthTemplate) {
  return dayjsFormat.call(this, template)
}

// new dayjs by time
dayjs.from = function (str, template = formatTimeTemplate) {
  if (str) {
    let dayjsObj
    if (str.length === 10) {
      dayjsObj = dayjs(str + '00:00:00', template)
    } else {
      dayjsObj = dayjs(str, template)
    }
    if (dayjsObj.isValid()) {
      return dayjsObj
    }
    return dayjs(str)
  }
  return dayjs()
}

window.dayjs = dayjs

/**
 * @deprecated 请使用 date.formatYearMonthDay 格式化日期
 * @link file://./date.js
 */
export function cbpDate(date) {
  return formatYearMonthDay(date)
}

/**
 * @deprecated 请使用 date.formatHMS 格式化时间
 * @link file://./date.js
 */
export function cbpTime(t, separate = ':') {
  if (!t) return '' // 检查输入是否为空
  // 尝试解析日期
  if (t.length == 6) {
    let h = t.substring(0, 2)
    let m = t.substring(2, 4)
    let s = t.substring(4, 6)
    return `${h}${separate}${m}${separate}${s}`
  }
  const parsedDate = dayjs(t)
  // 检查解析后的日期是否有效
  if (!parsedDate.isValid()) {
    return '' // 如果无效，返回空字符串
  }
  return parsedDate.format(`HH${separate}mm${separate}ss`)
}

export function random(length) {
  var str = Math.random().toString(36).substr(2)
  if (str.length >= length) {
    return str.substr(0, length)
  }
  str += random(length - str.length)
  return str
}

export function getFileType(filename = '') {
  let fileType = 'other'
  if (filename.match(/\.mp4$/i)) {
    fileType = 'video'
  } else if (filename.match(/\.(mp3)$/i)) {
    fileType = 'audio'
  } else if (filename.match(/\.(jpe?g|png|gif)/i)) {
    fileType = 'image'
  }
  return fileType
}
export function humanSize(size, ignorBit) {
  if (!size) return ''
  if (size < 1024) {
    if (ignorBit) {
      return '0KB'
    }
    return size + 'B'
  }
  size = size / 1024
  if (size > 1024) {
    size = (size / 1024).toFixed(1) + 'MB'
  } else {
    size = size.toFixed(1) + 'KB'
  }
  return size
}

export function saveBlobFile(blob, filename) {
  if (navigator.msSaveBlob) {
    // For ie and Edge
    return navigator.msSaveBlob(blob, filename)
  } else {
    let link = document.createElement('a')
    link.style = 'display: none'
    link.href = window.URL.createObjectURL(blob)
    link.download = filename
    document.body.appendChild(link)
    link.dispatchEvent(
      new MouseEvent('click', { bubbles: true, cancelable: true, view: window })
    )
    link.remove()
    window.URL.revokeObjectURL(link.href)
  }
}
export function downloadFile(url, filename = '') {
  let link = document.createElement('a')
  link.style = 'display: none'
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.dispatchEvent(
    new MouseEvent('click', { bubbles: true, cancelable: true, view: window })
  )
  link.remove()
}

export function getLabel(value, options = []) {
  if (typeof value !== 'string' && typeof value !== 'number') return ''
  for (let item of options) {
    if (item.value == value) {
      return item.getLabel ? item.getLabel() : item.label
    }
  }
  return value
}

export function getGuid() {
  // 替换最后四个字符为MBL2,作为后端确认设备来源
  let str =
    s4() +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    s4() +
    '_WEB'
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1)
  }
  return str.toUpperCase()
}
export function getReqId(id) {
  let s1 = ''
  if (id) {
    s1 = id + '-'
  }
  let s2 = Math.floor((1 + Math.random()) * 0x1000000000).toString(16)
  return s1 + s2 + '-' + Date.now()
}

export function handleNRCData(urls) {
  urls = urls || ''
  const urlArr = urls.split(';')
  let nrcFront = ''
  let nrcBack = ''
  let personal = ''
  // FRONT@xxx;BACK@xxxx;
  if (urls.indexOf('@') !== -1) {
    for (let item of urlArr) {
      const [type, url] = item.split('@')
      if (type === 'FRONT') {
        nrcFront = url
      } else if (type === 'BACK') {
        nrcBack = url
      } else if (type === 'PERSON') {
        personal = url
      }
    }
  } else {
    nrcFront = urlArr[0]
    nrcBack = urlArr[1]
    personal = urlArr[2]
  }
  if (nrcFront === 'null') {
    nrcFront = ''
  }
  if (nrcBack === 'null') {
    nrcBack = ''
  }
  if (personal === 'null') {
    personal = ''
  }
  return {
    nrcFront,
    nrcBack,
    personal
  }
}

/*
 * el-cascader递归获取父级id
 * @param  list 数据列表
 * @param  id 后端返回的id
 * @param  children 子类的key
 * @param  keyStr  idkey  默认 ‘id’
 **/
export function getParentsById(list, id, children, keyStr) {
  let key = keyStr
  if (!key) {
    key = 'id'
  }
  for (let i in list) {
    if (list[i][key] == id) {
      return [list[i][key]]
    }
    if (list[i][children]) {
      let node = getParentsById(list[i][children], id, children)
      if (node !== undefined) {
        node.unshift(list[i][key])
        return node
      }
    }
  }
}

export function printClick() {
  let el = document.getElementById('print_content')
  let doc = document
  let body = doc.body || doc.getElementsByTagName('body')[0]
  let printId = 'print-' + Date.now()
  let content = doc.createElement('div')
  content.id = printId
  let style = doc.createElement('style')
  style.innerHTML =
    'body>#' +
    printId +
    '{display:none}@media print{body>:not(#' +
    printId +
    '){display:none !important}body>#' +
    printId +
    '{display:block;padding-top:1px}}'
  content.innerHTML = el.outerHTML
  body.appendChild(style)
  body.appendChild(content)
  setTimeout(() => {
    window.print()
    body.removeChild(content)
    body.removeChild(style)
  }, 20)
}

export function getTimeDisplayText(tp, value) {
  if (!value) return ''
  const text = String(value)
  const digits = text.replace(/\D/g, '')
  // Day: '1', Month: '2', Quarter: '3', Year: '4'
  if (tp === '1') {
    return formatYearMonthDay(value) || text
  }
  if (tp === '2') {
    if (digits.length >= 6) {
      return `${digits.substring(4, 6)}/${digits.substring(0, 4)}`
    }
    return text
  }
  if (tp === '3') {
    const year = digits.substring(0, 4) || text.substring(0, 4)
    const q = digits.substring(4, 5) || text.substring(4, 5)
    const quarterText = {
      1: i18n.t('Quarter1'),
      2: i18n.t('Quarter2'),
      3: i18n.t('Quarter3'),
      4: i18n.t('Quarter4')
    }
    return quarterText[q] ? `${year} ${quarterText[q]}` : text
  }
  if (tp === '4') {
    const year = digits.substring(0, 4) || text.substring(0, 4)
    return year ? year + ' ' + i18n.t('SCRNITM#yr') : text
  }
  return text
}

export function getUrlQueries(query) {
  if (!query || typeof query !== 'string') return {}
  let obj = {}
  query = query.split('?').pop()
  let arr = query.split('&')
  for (let item of arr) {
    let temp = item.split('=')
    let key = temp[0]
    let value = decodeURIComponent(temp[1])
    if (key && value) {
      if (obj[key]) {
        obj[key] = Array.isArray(obj[key])
          ? obj[key].push(value)
          : [obj[key], value]
      } else {
        obj[key] = value
      }
    }
  }
  return obj
}

export function getXtnInfo(info = []) {
  let obj = {}
  info = Array.isArray(info) ? info : []
  for (let item of info) {
    obj[item.xtnAtrbtNm] = item.xtnAtrbtCntnt
  }
  return obj
}

/**
 * 递归删除对象中字符串字段的空格
 * @param {any} obj
 * @returns {any} obj
 */
export function trimStringField(obj = {}) {
  let objClone = Array.isArray(obj) ? [] : {}
  for (let key in obj) {
    if (typeof obj[key] === 'string') {
      objClone[key] = obj[key].trim()
    } else if (obj[key] && typeof obj[key] === 'object') {
      objClone[key] = trimStringField(obj[key])
    } else {
      objClone[key] = obj[key]
    }
  }
  return objClone
}

function fallbackCopy(text) {
  const textarea = document.createElement('textarea')
  textarea.value = text
  textarea.style.position = 'fixed'
  textarea.style.opacity = '0' // 也可以用透明
  textarea.style.left = '-9999px'
  document.body.appendChild(textarea)
  textarea.select()
  try {
    const result = document.execCommand('copy')
    document.body.removeChild(textarea)
    return true
  } catch (e) {
    document.body.removeChild(textarea)
    return false
  }
}

export async function copyText(text) {
  // 优先使用 Clipboard API
  if (navigator.clipboard && navigator.clipboard.writeText) {
    try {
      await navigator.clipboard.writeText(text)
      Message.success(i18n.t('LinkCopied'))
      return true
    } catch (err) {
      console.warn('Clipboard API 失败，尝试降级方案', err)
      // 失败后执行降级方案
      return fallbackCopy(text)
    }
  } else {
    // 直接执行降级方案
    return fallbackCopy(text)
  }
}
export function getAppScheme(path) {
  if (API_ENV === 'dev') {
    return 'jl-app-dev://customer/' + path
  }
  if (API_ENV === 'uat') {
    return 'jl-app-uat://customer/' + path
  }
  if (API_ENV === 'newuat') {
    return 'jl-app-newuat://customer/' + path
  }
  return 'jl-app://customer/' + path
}
